import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { tv } from 'tailwind-variants';
// Local
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const phKeyHalfLeft = `custom-container-half-left-${props?.params?.DynamicPlaceholderId || 'container-50-50'}`;
    const phKeyHalfRight = `custom-container-half-right-${props?.params?.DynamicPlaceholderId || 'container-50-50'}`;
    const { container, halfColumn } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsxs("div", {
        className: container(),
        ...getTestProps(`component-container-50-50-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: halfColumn(),
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeyHalfLeft,
                    rendering: props?.rendering,
                    ...getTestProps(`ph-left`)
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: halfColumn(),
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKeyHalfRight,
                    rendering: props?.rendering,
                    ...getTestProps(`ph-right`)
                })
            })
        ]
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'md:flex-row',
            'py-layout-base-margin-y',
            'gap-spacing-spacing-40',
            'md:gap-spacing-spacing-24'
        ],
        halfColumn: [
            'w-full',
            'md:w-1/2',
            'grid',
            'grid-cols-1',
            'gap-layout-base-margin-none'
        ]
    }
});
